import { Helmet } from "react-helmet";
import { PageMetadata } from "../../types/meta";

interface MetaProps {
  meta: PageMetadata | undefined;
}

const Meta = ({ meta }: MetaProps) => {
  return (
    <Helmet>
      <title>{`Randi.ai - ${meta?.title}`}</title>
      <meta name="thumbnail" content="https://randi.ai/showcase.jpg" />
      <meta name="robots" content="index, follow" />
      <meta name="description" content={meta?.description || ""} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={`https://randi.ai/${meta?.url}`} />
      <meta name="twitter:title" content={`Randi.ai - ${meta?.title}`} />
      <meta name="twitter:description" content={meta?.description || ""} />
      <meta name="twitter:image" content="https://randi.ai/showcase.jpg" />
      <meta property="og:url" content={`https://randi.ai/${meta?.url}`} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={`Randi.ai - ${meta?.title}`} />
      <meta property="og:description" content={meta?.description || ""} />
      <meta property="og:image" content="https://randi.ai/showcase.jpg" />
      <link rel="canonical" href="https://randi.ai/" />
    </Helmet>
  );
};

export default Meta;
